/* @generated */

// src/assets/ui-icon/sync/available-offline.tsx
import * as React from "react";
var AvailableOfflineSync = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Z",
    fill: "#00864C",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.03 12.97 9.062 11 8 12.061l3.03 3.03 5.031-5.03L15 9l-3.97 3.97Z",
    fill: "#fff",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  AvailableOfflineSync
};
